<template>
  <!-- prettier-ignore -->
  <div :class="classes">
    <template v-if="metaOptions.aide">
      <div class="footer-sections">
        <ul class="footer-list">
          <li>
            <a
              target="_blank"
              :href="$t('application.footer.imprint.link')">
              {{ $t('application.footer.imprint.title') }}
            </a>
          </li>
          <li>
            <a
              target="_blank"
              :href="$t('application.footer.legalNotice.link')">
              {{ $t('application.footer.legalNotice.title') }}
            </a>
          </li>
        </ul>
      </div>
    </template>

    <template v-else>
      <div class="footer-sections">
        <div class="footer-section">
          <template v-if="contactInfo && contactInfo.phone && contactInfo.phone.enabled">
            <strong v-text="contactInfo.phone.name" />
            <div
              v-for="(time, index) in contactInfo.phone.times"
              :key="index">
              {{ time.days }} {{ time.hours }}
            </div>
            <a
              :class="{'phone--disabled': !contactInfo.phone.active}"
              :href="`tel:${contactInfo.phone.nr}`">
              <the-icon
                art="solid"
                name="phone"
              />
              {{ contactInfo.phone.nr }}
            </a>

            <template v-if="basket.channel === CHANNEL.PARTNERDVP">
              <a
                :href="`mailto:${contactInfo.email[basket.language.toLowerCase()]}`">
                <the-icon
                  art="solid"
                  name="at"
                />
                {{ contactInfo.email[basket.language.toLowerCase()] }}
              </a>
            </template>
          </template>
        </div>


        <div class="footer-section">
          <strong v-text="$t('application.footer.help')" />

          <!-- id used for teleport target -->
          <div
            v-if="showOverview"
            id="ovpContractOverview"
          >
            <template v-if="showDefaultOverviewLink">
              <Form.Button
                v-unblu-hidden
                :text="$t('application.footer.showOverviewPdf')"
                text-link
                @click="openDocument"
              />
            </template>
          </div>
          <a
            :href="$t('screen.submit.furtherOptions.cancellation.href')"
            target="_blank"
            v-text="$t('screen.submit.furtherOptions.cancellation.link')"
          />
        </div>
      </div>

      <div class="footer-sections">
        <ul class="footer-list">
          <li>
            <a
              target="_blank"
              :href="$t('application.footer.imprint.link')">
              {{ $t('application.footer.imprint.title') }}
            </a>
          </li>
          <li>
            <a
              target="_blank"
              :href="$t('application.footer.legalNotice.link')">
              {{ $t('application.footer.legalNotice.title') }}
            </a>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useBasket, useContact, useOvp, useStatus } from '@/hooks'
import * as Form from '@/components/Form'

import { CHANNEL, ROUTE_NAME } from '@/config/constants'

// HOOKS
const route = useRoute()
const { contactInfo } = useContact()
const { basket } = useBasket()
const { getDocument } = useOvp()
const { isOnboardingSecured } = useStatus()

// PROPS
const props = defineProps({
  metaOptions: {
    type: Object,
    default: () => {},
  },
})

// COMPUTED
const classes = computed(() => {
  return {
    footer: true,
    footer__aide: props.metaOptions.aide,
  }
})

const showOverview = computed(() => {
  return isOnboardingSecured.value && route.name !== ROUTE_NAME.REENTRY
})

const showDefaultOverviewLink = computed(() => {
  return !route.meta.hideDefaultOverviewLink
})

// METHODS
function openDocument() {
  getDocument({
    basketId: basket.basketId,
    fileName: 'overview',
  })
}
</script>

<style name="mobile" scoped>
.footer {
  display: flex;
  flex-direction: column;
  padding: 50px 15px;
  color: var(--c-primary-neutral-1);
  font-size: 15px;

  &-sections {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--c-secondary-neutral-3);
  }

  &-section {
    flex: 1 1 auto;
    margin-bottom: 25px;

    a {
      display: block;
    }
  }

  &-list {
    display: flex;
    align-items: center;
    justify-content: center;
    list-style: none;
    width: 100%;
    padding: 0;

    li {
      margin-right: 20px;
      padding-bottom: unset;
      list-style: none;

      a {
        font-size: 12px;
        font-weight: 600;
        text-decoration: none;
      }
    }
  }
}

.phone--disabled {
  pointer-events: none;
  color: var(--c-secondary-neutral-2);

  & :deep(.icon) {
    color: var(--c-secondary-neutral-2);
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .footer {
    padding: 50px 15px;
  }

  .footer-sections {
    display: flex;
    flex-direction: row;
  }

  .footer-section {
    flex: 0 1 auto;
    min-width: 300px;
    min-height: 100px;
    margin-bottom: 0;
  }
}
</style>

<style name="global">
#reentryModal {
  padding: 15px 15px 0;
}

#reentryModal {
  form {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    button {
      margin-top: 20px;
      min-width: 200px;
      align-self: flex-end;
    }
  }
}
</style>
